import React from "react";
import { Reveal } from "./Reveal";
import { Phone, Instagram, MapPin, Clock, Navigation, Mail } from "lucide-react";
import { SITE } from "../data/site";

export const ContactSection = () => (
  <section id="contact" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5">
        <Reveal><span className="overline">06 — Come as you are</span></Reveal>
        <Reveal delay={0.05}>
          <h2 className="section-title text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight text-[#20301A]">
            Reach the practice
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 text-[#55703F] leading-relaxed max-w-md">
            Call, message on Instagram, or drop by the studio in Jubilee Hills. Online sessions are available
            for clients anywhere.
          </p>
        </Reveal>

        <div className="mt-8 space-y-3">
          <Reveal delay={0.12}>
            <a data-testid="contact-phone-link" href={`tel:${SITE.phoneTel}`}
              className="hover-lift flex items-center gap-4 rounded-2xl bg-[#DFF0C4] border border-[#C9DFAC] p-4">
              <span className="grid place-items-center w-11 h-11 rounded-full bg-[#3A7D32] text-[#F2F8E8]"><Phone size={18} /></span>
              <div><div className="text-[0.7rem] font-mono uppercase tracking-widest text-[#55703F]">Call / WhatsApp</div>
              <div className="text-[#20301A] font-medium">{SITE.phone}</div></div>
            </a>
          </Reveal>
          <Reveal delay={0.16}>
            <a data-testid="contact-instagram-link" href={SITE.instagram} target="_blank" rel="noreferrer"
              className="hover-lift flex items-center gap-4 rounded-2xl bg-[#FFEFDF] border border-[#FFC9A0] p-4">
              <span className="grid place-items-center w-11 h-11 rounded-full bg-[#3A7D32] text-[#F2F8E8]"><Instagram size={18} /></span>
              <div><div className="text-[0.7rem] font-mono uppercase tracking-widest text-[#55703F]">Instagram</div>
              <div className="text-[#20301A] font-medium">{SITE.instagramHandle}</div></div>
            </a>
          </Reveal>
          <Reveal delay={0.2}>
            <a data-testid="contact-email-link" href={`mailto:${SITE.email}`}
              className="hover-lift flex items-center gap-4 rounded-2xl bg-[#F7EBC6]/60 border border-[#EADB9B] p-4">
              <span className="grid place-items-center w-11 h-11 rounded-full bg-[#3A7D32] text-[#F2F8E8]"><Mail size={18} /></span>
              <div><div className="text-[0.7rem] font-mono uppercase tracking-widest text-[#55703F]">Email to book</div>
              <div className="text-[#20301A] font-medium break-all">{SITE.email}</div></div>
            </a>
          </Reveal>
          <Reveal delay={0.24}>
            <div className="flex items-center gap-4 rounded-2xl bg-[#D8E5ED]/50 border border-[#B8D1E0] p-4">
              <span className="grid place-items-center w-11 h-11 rounded-full bg-[#3A7D32] text-[#F2F8E8]"><Clock size={18} /></span>
              <div><div className="text-[0.7rem] font-mono uppercase tracking-widest text-[#55703F]">Hours</div>
              <div className="text-[#20301A] font-medium">{SITE.hours}</div></div>
            </div>
          </Reveal>
        </div>
      </div>

      <Reveal delay={0.1} className="lg:col-span-7">
        <div className="rounded-[28px] overflow-hidden border border-[#C9DFAC] soft-shadow h-full min-h-[420px] relative bg-[#DFF0C4]">
          <iframe title="map" className="w-full h-full min-h-[420px] grayscale-[0.2]" loading="lazy"
            src="https://www.google.com/maps?q=Jubilee+Hills+Filmnagar+Hyderabad&output=embed" />
          <div className="absolute bottom-5 left-5 right-5 glass rounded-2xl p-5 border border-white/40">
            <div className="flex items-start gap-3">
              <MapPin size={18} className="text-[#3A7D32] mt-0.5 shrink-0" />
              <p data-testid="contact-address-text" className="text-sm text-[#20301A] leading-relaxed">{SITE.address}</p>
            </div>
            <a href={SITE.maps} target="_blank" rel="noreferrer" data-testid="contact-directions-link"
              className="mt-3 inline-flex items-center gap-2 text-sm text-[#3A7D32] font-medium border-b border-[#3A7D32] pb-0.5">
              <Navigation size={14} /> Get directions
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
